import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Questions from './Questions/Questions';
import classes from './FAQ.module.scss';
const FAQ = () => {
    return (_jsxs("div", { className: "grid-block", "data-testid": "faq", children: [_jsx("h2", { className: classes.title, children: "\u041E\u0442\u0432\u0435\u0442\u044B \u043D\u0430 \u0432\u043E\u043F\u0440\u043E\u0441\u044B" }), _jsx(Questions, {})] }));
};
export default FAQ;
